import React from 'react';

// Mobx
import { inject, observer } from 'mobx-react';

// Icons
import 'font-awesome/css/font-awesome.min.css';

// Navigation
import { useNavigate, Navigate, Link } from 'react-router-dom';

// Alert Dialog
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

// Yup
import * as yup from 'yup';

// Formik
import { Form, Formik } from 'formik';

// Helpers
import Helpers from '../../helpers';

// Css
import '../../assets/css/app.css';

// Layout
import CommerceLayout from '../layouts/CommerceLayout';

// Components
import LoginForm from '../../components/LoginForm';
import FunctionalButton from '../../components/Buttons/FunctionalButton';
import FunctionalTextInput from '../../components/Inputs/FunctionalInput';

@inject('AuthStore', 'ShoppingCartStore')
@observer
class UpdatePasswordSettings extends React.Component<any> {
    constructor(props: any) {
        super(props);
    }

    render() {
        const storeId: any = localStorage.getItem('storeId');
        const initialValues: any = {
            password: '',
            new_password: '',
            new_password_again: ''
        };

        return (
            storeId !== null ?
                <CommerceLayout
                    title={Helpers.translation('update_password')}
                    visibleCategories={false}
                >
                    <section id="breadcrumbs" className="pt-6 bg-gray-50">
                        <div className="container mx-auto px-4 text-xs md:text-base">
                            <ol className="list-reset flex">
                                <li>
                                    <Link
                                        className="font-semibold hover:text-primary"
                                        to={`/home`}
                                    >
                                        {Helpers.translation('home')}
                                    </Link>
                                </li>
                                <li>
                                    <span className="mx-2">&gt;</span>
                                </li>
                                <li>
                                    <Link
                                        className="font-semibold hover:text-primary"
                                        to={`/profile`}
                                    >
                                        {Helpers.translation('profile')}
                                    </Link>
                                </li>
                                <li>
                                    <span className="mx-2">&gt;</span>
                                </li>
                                <li>{Helpers.translation('update_password')}</li>
                            </ol>
                        </div>
                    </section>

                    {
                        this.props.AuthStore.userData.isLogin ?
                            <section id="shop">
                                <div className="container mx-auto p-4">
                                    <div className="flex flex-col">
                                        <div className="w-full">
                                            <Formik
                                                initialValues={initialValues}
                                                onSubmit={async (values: any, { resetForm }) => {
                                                    const response = await Helpers.passwordChange(values);

                                                    if (response.status === true) {
                                                        resetForm(initialValues)
                                                    }
                                                }}
                                                validationSchema={yup.object().shape({
                                                    password: yup
                                                        .string()
                                                        .required(Helpers.translation('password_input_require_error')),
                                                    new_password: yup
                                                        .string()
                                                        .required(Helpers.translation('password_input_require_error')),
                                                    new_password_again: yup
                                                        .string()
                                                        .required(Helpers.translation('password_input_require_error'))
                                                })}
                                            >
                                                {(props: any) => {
                                                    return (
                                                        <Form className="w-full">
                                                            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
                                                                <FunctionalTextInput
                                                                    name="password"
                                                                    placeholder={Helpers.translation('password')}
                                                                    label={Helpers.translation('password')}
                                                                    errors={props.errors.password}
                                                                    value={props.values.password}
                                                                    secureTextStatus
                                                                />

                                                                <FunctionalTextInput
                                                                    name="new_password"
                                                                    placeholder={Helpers.translation('new_password')}
                                                                    label={Helpers.translation('new_password')}
                                                                    errors={props.errors.new_password}
                                                                    value={props.values.new_password}
                                                                    secureTextStatus
                                                                />

                                                                <FunctionalTextInput
                                                                    name="new_password_again"
                                                                    placeholder={Helpers.translation('new_password_again')}
                                                                    label={Helpers.translation('new_password_again')}
                                                                    errors={props.errors.new_password_again}
                                                                    value={props.values.new_password_again}
                                                                    secureTextStatus
                                                                />
                                                            </div>

                                                            <FunctionalButton
                                                                text={Helpers.translation('update')}
                                                                fullWidth={false}
                                                                customClasses="mt-4"
                                                                rounded
                                                            />
                                                        </Form>
                                                    )
                                                }}
                                            </Formik>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            :
                            <LoginForm
                                message={Helpers.translation('you_need_login_for_view_this_page')}
                            />
                    }
                </CommerceLayout>
                :
                <Navigate to="/" replace={true} />
        )
    }
}

function WithNavigate(props: any) {
    let navigate = useNavigate();
    return <UpdatePasswordSettings {...props} navigate={navigate} />
}

export default WithNavigate;